// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

//packages
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import VueTagsInput from '@johmun/vue-tags-input';
import vSelect from 'vue-select';
import PictureInput from 'vue-picture-input';
import VueRouter from 'vue-router';
import VueCharts from 'vue-chartjs';
import vue2Dropzone from 'vue2-dropzone';
import Snotify from 'vue-snotify'; 
import { Sketch, Material } from 'vue-color';
import Datetime from 'vue-datetime';
import VueGoogleCharts from 'vue-google-charts';
import ToggleButton from 'vue-js-toggle-button'
import wysiwyg from 'vue-wysiwyg';
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import VueTelInput from 'vue-tel-input';
import DatePicker from 'vue2-datepicker';
import VueSlider from 'vue-slider-component'
import VCalendar from 'v-calendar';
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import { store } from './store/store';
import { UPLOAD_TINCAN_FILE, AUTH_HEADER, global_config } from './config.js';
import App from './App'

Vue.config.productionTip = false;

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});
Vue.use(Datetime)
Vue.use(VueTagsInput);
Vue.use(PictureInput);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(VueCharts);

Vue.use(Datetime);
Vue.use(ToggleButton)
Vue.use(VueGoogleCharts);
Vue.use(wysiwyg, {});
Vue.use(VueTelInput);
Vue.use(DatePicker);
Vue.component('vue-slider', VueSlider);
Vue.component('draggable', draggable);
Vue.component('multiselect', Multiselect);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import "vue-snotify/styles/material.css";
import 'vue-datetime/dist/vue-datetime.css';

import 'vue-slider-component/theme/antd.css'
import 'vue2-datepicker/index.css';
import './assets/css/main.css';
import "vue-wysiwyg/dist/vueWysiwyg.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import 'vue-tel-input/dist/vue-tel-input.css';
//routes import
import { routes } from './routes';

const router = new VueRouter({
    mode: 'history',
    routes,
    base: '/'
});


//import components
import HeaderComponent from './components/shared/HeaderComponent';
import FooterComponent from './components/shared/FooterComponent';
import AsideComponent from './components/shared/AsideComponent';
import LoginComponent from './components/auth/LoginComponent';
import MenuComponent from './components/shared/MenuComponent';
import AdminProviderListComponent from './components/admin/providers/AdminProviderListComponent';
import TagComponent from './components/shared/TagComponent';
import SignUpsPieChartComponent from './components/charts/SignUpsPieChartComponent';
import ProgramScheduleChartComponent from './components/charts/ProgramScheduleChartComponent';
import HoursLearnedChartComponent from './components/charts/HoursLearnedChartComponent';
import AdminLHCSADashboardChart1Component from './components/charts/AdminLHCSADashboardChart1Component';
import LHCSADashboardChart1Component from './components/charts/LHCSADashboardChart1Component';
import ProgramProgressCompletionComponent from './components/charts/ProgramProgressCompletionComponent';
import AdminProgramsDetailChartComponent from './components/charts/AdminProgramsDetailChartComponent';
import ProviderOrganizationDetailComponent from './components/shared/ProviderOrganizationDetailComponent';
import NewProviderComponent from './components/shared/NewProviderComponent';
import AddProviderToCourseComponent from './components/shared/AddProviderToCourseComponent';
import ProviderListComponent from './components/shared/ProviderListComponent';
import CustomMessageModal from './components/shared/CustomMessageModal';
import DatePickerTextComponent from './components/shared/inputs/DatePickerTextComponent';
import CustomerSuccessPanelMain from "./components/csp/CustomerSuccessPanelMain";
import CustomerSuccessProviderList from "./components/csp/CustomerSuccessProviderList";
import SignUpProgressBar from "./components/shared/SignUpProgressBar";
import PasswordDropdown from "./components/shared/PasswordDropdown";
import SMETableView from "./components/sme/SharedViews/SMETableView";
import SMETableViewCourse from "./components/sme/SharedViews/SMETableViewCourse";
import SMEModalsView from "./components/sme/SharedViews/SMEModalsView";
import PasswordActionItems from "./components/shared/PasswordActionItems"
import TableView from "./components/shared/profile/TableView";
import AgenyDetailTable from "./components/shared/profile/AgencyDetailTables";
import TableViewActions from "./components/shared/profile/TableViewActions";

//register components
Vue.component('app-header-component', HeaderComponent);
Vue.component('app-footer-component', FooterComponent);
Vue.component('app-login-component', LoginComponent);
Vue.component('app-aside-component', AsideComponent);
Vue.component('app-menu-component', MenuComponent);
Vue.component('v-select', vSelect);
Vue.component('vue-dropzone', vue2Dropzone);
Vue.component('admin-provider-list-component', AdminProviderListComponent);
Vue.component('color-picker', Sketch);
Vue.component('tags', TagComponent);
Vue.component('provider-organization', ProviderOrganizationDetailComponent);
Vue.component('new-provider', NewProviderComponent);
Vue.component('add-provider-to-course', AddProviderToCourseComponent);
Vue.component('provider-list', ProviderListComponent);
Vue.component('custom-message-modal', CustomMessageModal);
Vue.component('date-picker-text', DatePickerTextComponent);
Vue.component("csp-main", CustomerSuccessPanelMain);
Vue.component("csp-provider-list", CustomerSuccessProviderList);
Vue.component("password-reset", PasswordDropdown);
Vue.component("password-action", PasswordActionItems);
Vue.component("table-view", TableView);
Vue.component("agency-tables", AgenyDetailTable);
Vue.component("table-actions", TableViewActions);
Vue.component("sme-table", SMETableView);
Vue.component("table-view-course", SMETableViewCourse);
Vue.component("sme-modals", SMEModalsView);


//charts
Vue.component('sign-ups-pie-chart', SignUpsPieChartComponent);
Vue.component('program-schedule-chart', ProgramScheduleChartComponent);
Vue.component('admin-lhcsa-dashboard-chart-1', AdminLHCSADashboardChart1Component);
Vue.component('lhcsa-dashboard-chart-1', LHCSADashboardChart1Component);
Vue.component('program-progress-completion', ProgramProgressCompletionComponent);
Vue.component('hours-learned', HoursLearnedChartComponent);
Vue.component('admin-programs-detail-chart', AdminProgramsDetailChartComponent);
Vue.component("sign-up-progress-bar", SignUpProgressBar);

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'formFields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messsages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false,
};

const snotify_config = {
  global: {
    pauseOnHover: true,
    newOnTop: true,
  },
  toast: {
    timeout: 10000
  }

}
Vue.use(Snotify,snotify_config);

Vue.use(VeeValidate, config);

/** CUSTOM CONFIG **/

Vue.prototype.upload_urls = {
  UPLOAD_TINCAN_FILE : UPLOAD_TINCAN_FILE
}

Vue.prototype.api_config = {
  AUTH_HEADER : AUTH_HEADER
}

Vue.prototype.config = global_config;
Vue.prototype.page_loading = true;


Vue.filter('format_url', function(value, params){

  var url = value;

  var str_params = '';
  if(params){
    str_params = '?';
    var parts = [];
    for(var i in params){
      var value = params[i];

      if(typeof(params[i]) == 'object'){
        var ids = [];
        for(var j in params[i]){
          ids.push(params[i][j].id);
        }

        value = ids.join(',');
      }
      
      parts.push(i + "=" + value);
    } 

    str_params = '?'+parts.join("&"); 
  }

  return url + str_params;
  
});

Vue.filter('format_percent_no_dec', function(value){

  return Math.round(value);
})

Vue.filter('yes_no', function(value){
  return value == 0 ? 'No' : 'Yes';  
});

Vue.filter('format_date', function(value){
  if(value){
    var date = value.split('-');

    return date[1] + '/' + date[2] + '/' + date[0];
  }  
});

Vue.filter('format_duration_method', function(value){

  switch(value){
    case '0' :
      return '-';
    case '1' : 
      return 'Jan - Dec';
    case '2' :
      return 'By Employee Employment Date';

    default : 
      return '-';
  }
})

/* eslint-disable no-new */
export var vue_instance = new Vue({
  el: '#app',
  components: { 
  	App
  },
  template: '<App/>',
  store,
  router  
});







// WEBPACK FOOTER //
// ./src/main.js